import React, { useState, useEffect } from "react";
import { Image, StrictImageProps } from "semantic-ui-react";

import {
  getLargeThumbnailLink,
  getThumbnailLink,
} from "../../../helpers/globalFunctions";
import { PLACEHOLDER_16_TO_9 } from "../../../images/imageSources";

export enum definedAspectRatios {
  aspect18to3 = "16.67%",
  aspect18to6 = "33.33%",
  aspect21to9 = "42.85%",
  aspect16to9 = "56.25%",
  aspect4to3 = "75%",
  aspect3to22 = "66.66%",
  aspect8to5 = "62.5%",
  aspect1to1 = "100%",
}

export interface IPlaceholdableImageProps extends StrictImageProps {
  src?: string;
  fallbackImage?: string;
  thumbnail?: boolean;
  alt?: string;
}

const PlaceHoldableImage: React.FC<IPlaceholdableImageProps> = ({
  src,
  fallbackImage,
  thumbnail,
  alt,
  size,
  ...props
}) => {
  const [img, setImg] = useState({
    src: undefined as undefined | string,
    thumbnailError: false,
    fallbackError: false,
  });

  useEffect(() => {
    if (src) {
      let source = src;
      if (thumbnail && size === "massive") {
        source = getLargeThumbnailLink(src) || src;
      } else if (thumbnail) {
        source = getThumbnailLink(src) || src;
      }
      setImg({
        src: source,
        thumbnailError: !thumbnail,
        fallbackError: false,
      });
    } else {
      setImg({
        src: fallbackImage || PLACEHOLDER_16_TO_9,
        thumbnailError: true,
        fallbackError: true,
      });
    }
  }, [src, fallbackImage, thumbnail, size]);

  const onError = () => {
    if (!src) return;

    const { thumbnailError, fallbackError } = img;
    if (!thumbnailError && !fallbackError) {
      setImg({
        src,
        thumbnailError: true,
        fallbackError: false,
      });
    }
    if (thumbnailError && !fallbackError) {
      setImg({
        src: fallbackImage || PLACEHOLDER_16_TO_9,
        thumbnailError: true,
        fallbackError: true,
      });
    }
    if (thumbnailError && fallbackError) {
      // Do nothing because all images have errored :(
    }
  };

  return (
    <Image alt={alt} size={size} src={img.src} onError={onError} {...props} />
  );
};

export default PlaceHoldableImage;
